// app/ningenie/lib/ningenie-defaults.ts
// baby: Default categories and accounts for new users (without transactions/budgets)

import {
  NinGenieAccount,
  NinGenieCategory
} from './ningenie-types'

const nowIso = () => new Date().toISOString()

// baby: default categories for new users
export const DEFAULT_CATEGORIES: NinGenieCategory[] = [
  {
    id: 'cat-gifts',
    name: 'Gifts',
    type: 'expense',
    iconKey: 'gift',
    color: '#f97316'
  },
  {
    id: 'cat-travel',
    name: 'Travel',
    type: 'expense',
    iconKey: 'travel',
    color: '#1d4ed8'
  },
  {
    id: 'cat-fuel',
    name: 'Fuel',
    type: 'expense',
    iconKey: 'fuel',
    color: '#f43f5e'
  },
  {
    id: 'cat-undefined-expense',
    name: 'Undefined',
    type: 'expense',
    iconKey: 'question',
    color: '#6b7280'
  },
  {
    id: 'cat-gifts-income',
    name: 'Gifts',
    type: 'income',
    iconKey: 'gift',
    color: '#22c55e'
  },
  {
    id: 'cat-travel-income',
    name: 'Travel',
    type: 'income',
    iconKey: 'travel',
    color: '#38bdf8'
  },
  {
    id: 'cat-fuel-income',
    name: 'Fuel',
    type: 'income',
    iconKey: 'fuel',
    color: '#a855f7'
  },
  {
    id: 'cat-undefined-income',
    name: 'Undefined',
    type: 'income',
    iconKey: 'question',
    color: '#475569'
  }
]

// baby: default accounts for new users (with zero balances)
export const DEFAULT_ACCOUNTS: NinGenieAccount[] = [
  {
    id: 'account-paytm-wallet',
    name: 'Paytm Wallet',
    type: 'wallet',
    institution: 'Paytm',
    initialBalance: 0,
    balance: 0,
    currency: 'INR',
    iconKey: 'paytm',
    color: '#2563eb',
    lastUpdated: nowIso()
  },
  {
    id: 'account-card',
    name: 'Card (ICICI)',
    type: 'card',
    institution: 'ICICI',
    initialBalance: 0,
    balance: 0,
    currency: 'INR',
    iconKey: 'card',
    color: '#1c4b5a',
    lastUpdated: nowIso()
  },
  {
    id: 'account-cash',
    name: 'Cash',
    type: 'cash',
    initialBalance: 0,
    balance: 0,
    currency: 'INR',
    iconKey: 'cash',
    color: '#f97316',
    lastUpdated: nowIso()
  },
  {
    id: 'account-savings',
    name: 'Savings',
    type: 'bank',
    institution: 'SBI',
    initialBalance: 0,
    balance: 0,
    currency: 'INR',
    iconKey: 'bank',
    color: '#0f172a',
    lastUpdated: nowIso()
  },
  {
    id: 'account-upi-icici',
    name: 'UPI1(7777777777@okicici)',
    type: 'upi',
    institution: 'ICICI',
    initialBalance: 0,
    balance: 0,
    currency: 'INR',
    iconKey: 'upi',
    color: '#0891b2',
    lastUpdated: nowIso()
  },
  {
    id: 'account-phonepe',
    name: 'PhonePe',
    type: 'upi',
    institution: 'PhonePe',
    initialBalance: 0,
    balance: 0,
    currency: 'INR',
    iconKey: 'phonepe',
    color: '#7c3aed',
    lastUpdated: nowIso()
  },
  {
    id: 'account-gpay',
    name: 'GPay',
    type: 'upi',
    institution: 'Google',
    initialBalance: 0,
    balance: 0,
    currency: 'INR',
    iconKey: 'gpay',
    color: '#38bdf8',
    lastUpdated: nowIso()
  },
  {
    id: 'account-ningenie-upi',
    name: 'NINJAPAY UPI',
    type: 'upi',
    institution: 'NINJAPAY',
    initialBalance: 0,
    balance: 0,
    currency: 'INR',
    iconKey: 'ninjapay',
    color: '#10b981',
    lastUpdated: nowIso()
  },
  {
    id: 'account-earnings',
    name: 'NINJAPAY (My Earnings)',
    type: 'virtual',
    institution: 'NINJAPAY',
    initialBalance: 0,
    balance: 0,
    currency: 'INR',
    iconKey: 'earnings',
    color: '#0ea5e9',
    lastUpdated: nowIso()
  }
]

